import { render, staticRenderFns } from "./report-form-127.vue?vue&type=template&id=10c52cac&scoped=true&"
import script from "./report-form-127.vue?vue&type=script&lang=ts&"
export * from "./report-form-127.vue?vue&type=script&lang=ts&"
import style0 from "./report-form-127.vue?vue&type=style&index=0&id=10c52cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c52cac",
  null
  
)

export default component.exports